import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ffdf382"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "check-paymant-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "check-paymant-block"
}
const _hoisted_4 = { class: "cash-paymant-block-name" }
const _hoisted_5 = { class: "first-subsection" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = { class: "label" }
const _hoisted_9 = {
  key: 0,
  class: "label"
}
const _hoisted_10 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewHeader = _resolveComponent("ViewHeader")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_DropdownInput = _resolveComponent("DropdownInput")!
  const _component_TotalRow = _resolveComponent("TotalRow")!
  const _component_BackAndCancelFooter = _resolveComponent("BackAndCancelFooter")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ViewHeader, {
      text: _ctx.$t('newOrder.add-ccard-payment')
    }, null, 8, ["text"]),
    (_ctx.frameUrl)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 0,
          class: "frame",
          src: _ctx.frameUrl,
          frameborder: "0"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("form", {
            action: "",
            id: "paymentForm",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
            novalidate: ""
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('cashier.label.creditcard')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('cashier.label.amount')), 1),
              _createVNode(_component_NumberInput, {
                modelValue: _ctx.payment.amount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payment.amount) = $event)),
                scope: _ctx.validation.scope,
                rules: _ctx.validation.rules.amount,
                mode: "decimal",
                minFractionDigits: 2,
                maxFractionDigits: 2,
                inputProps: { 'data-index': 1 },
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([1])), ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "scope", "rules"]),
              _hoisted_7,
              _createVNode(_component_DropdownInput, {
                onChange: _ctx.changeCurrency,
                modelValue: _ctx.payment.currencyId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payment.currencyId) = $event)),
                options: _ctx.currencies,
                optionLabel: "name",
                optionValue: "id",
                placeholder: _ctx.$t('cashier.placeholder.select-currency'),
                scope: _ctx.validation.scope,
                rules: _ctx.validation.rules.currencyId,
                inputProps: { 'data-index': 2 }
              }, null, 8, ["onChange", "modelValue", "options", "placeholder", "scope", "rules"]),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('cashier.label.type')), 1),
              _createVNode(_component_DropdownInput, {
                style: {"grid-column":"span 3"},
                modelValue: _ctx.payment.creditCardPaymentType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payment.creditCardPaymentType) = $event)),
                options: _ctx.creditCardPaymentTypes,
                optionLabel: "name",
                optionValue: "id",
                placeholder: _ctx.$t('cashier.label.select-type'),
                scope: _ctx.validation.scope,
                rules: _ctx.validation.rules.creditCardPaymentType,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.focusNext([3,4]))),
                inputProps: { 'data-index': 3 }
              }, null, 8, ["modelValue", "options", "placeholder", "scope", "rules"]),
              (_ctx.payment.creditCardPaymentType != 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('cashier.label.payments')), 1))
                : _createCommentVNode("", true),
              (_ctx.payment.creditCardPaymentType != 1)
                ? (_openBlock(), _createBlock(_component_DropdownInput, {
                    key: 1,
                    modelValue: _ctx.payment.numberOfPayments,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payment.numberOfPayments) = $event)),
                    options: [{ value: 1 }, { value: 2 }, { value: 3 }],
                    optionLabel: "value",
                    optionValue: "value",
                    placeholder: _ctx.$t('cashier.placeholder.select-payments'),
                    scope: _ctx.validation.scope,
                    inputProps: { 'data-index': 4 },
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.focusNext([4])))
                  }, null, 8, ["modelValue", "placeholder", "scope"]))
                : _createCommentVNode("", true)
            ])
          ], 32),
          _createVNode(_component_TotalRow, {
            total: _ctx.total,
            paymentCurrencyId: _ctx.payment.currencyId
          }, null, 8, ["total", "paymentCurrencyId"]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              "data-index": "5",
              class: "p-ripple submit-btn",
              type: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearCreditCard && _ctx.clearCreditCard(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('cashier.label.clear-credit-card')), 1)
            ])), [
              [_directive_ripple]
            ])
          ])
        ])),
    _createVNode(_component_BackAndCancelFooter)
  ]))
}